import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function PopularRentalCarsRentNow({ handleClick }) {
  const t = useTranslationDetector();

  return (
    <>
      <FontAwesomeIcon
        className="text-second-color w-min"
        fontSize={30}
        icon={byPrefixAndName.far["cars"]}
      />
      <div className="font-sofia-sans text-lg leading-[24px] font-semibold">
        {t("Car.rentNowTitle")}
      </div>
      <div className="text-muted-color text-sm leading-[19px]">
        {t("Car.rentNowDescription")}
      </div>
      <div className="relative mt-8 flex w-full min-w-[275px] justify-center">
        <button
          className="text-second-color flex items-center gap-2 select-none"
          onClick={handleClick}
        >
          {t("Car.RentNowHome")}
          <FontAwesomeIcon
            className="rtl:rotate-180"
            icon={byPrefixAndName.far["arrow-right"]}
          />
        </button>
      </div>
    </>
  );
}
